<template>
  <div class="producers" v-if="producers.length > 0">
    <h2 class="producers__title">{{ str('efriends.producersTitle') }}</h2>
    <div class="producers__list">
      <transition-group name="producers__list-item" tag="div">
        <div
          v-for="producer in producers"
          :key="producer.cubeName"
          class="producers__list-item"
        >
          <Producer :producer="producer" />
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
  import Producer from '@/components/efriends/Producer'

  export default {
    name: 'producers',
    components: { Producer },
    computed: {
      producers: function () {
        return this.$store.getters.producers.filter((consumer) => {
          return !consumer.isContributor
        })
      },
    },
  }
</script>

<style lang="scss">
  .producers {
    margin: spacer(2) auto 0;
    max-width: 800px;

    &__list {
      &-item {
        transition: all 1s ease-in-out 0s;

        &-leave-active {
          max-height: 0;
          padding-top: 0;
          padding-bottom: 0;
          overflow: hidden;
        }
      }
    }
  }
</style>
